'use client';

import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type FeatureProps = {
  icon: ReactNode;
  title: string;
  description: string;
};

const Feature = ({ icon, title, description }: FeatureProps) => {
  return (
    <div className='rounded-md bg-white flex flex-col flex-1 items-center justify-center text-center gap-3 p-4 h-fill'>
      <div className='text-3xl'>{icon}</div>
      <div className='flex flex-col gap-2'>
        <h3 className='font-semibold text-base'>{title}</h3>
        <p className='text-zinc-500 text-sm font-medium'>{description}</p>
      </div>
    </div>
  );
};

type FeaturesProps = {
  features: Array<{
    icon: ReactNode;
    title: string;
    description: string;
  }>;
  className?: string;
};

export const Features = ({ features, className }: FeaturesProps) => {
  return (
    <div
      className={cn('grid grid-col-1 sm:grid-flow-col gap-3 h-full', className)}
    >
      {features.map((feature, index) => (
        <Feature key={index} {...feature} />
      ))}
    </div>
  );
};
